<template>
  <WdsStack align-center :data-test="`tc-name-${index}`">
    <WdsAvatar
      sm
      :path="contact?.avatarPath"
      :class="{
        'tw-opacity-40': contact.managedStatus === TrustedContactManagedStatus.Unmanaged,
      }"
    />

    <WdsStack direction-column class="tw-ml-2.5 lg:tw-max-w-[200px] xl:tw-max-w-none">
      <WdsText>
        <template #default>
          <WorkerName
            :name="contact.name"
            :manages-workers="contact.hiresWithAttribution[0]?.recruiterManagesWorkers ?? false"
            :managed-status="contact.managedStatus"
            :recruiter-name="contact.hiresWithAttribution[0]?.recruiter?.name"
            :recruiter-fee-percentage="contact.hiresWithAttribution[0]?.recruiterFee"
            :recruiter-ownership-start-date="
              contact.hiresWithAttribution[0]?.recruiterOwnershipStartDate
            "
            :recruiter-ownership-days="contact.hiresWithAttribution[0]?.recruiterOwnershipDays"
            :recruiter-ownership-days-left="
              contact.hiresWithAttribution[0]?.recruiterOwnershipDaysLeft
            "
          />

          <WdsStack direction-row gap-sm>
            <TrustedContactStatusLabel
              v-if="withStatus"
              :status="contact.status"
              :data-test="`tc-status-${index}`"
              :index="index"
              xs
            />

            <WdsLabel
              v-if="contact.isCurrentlyHired && withHireStatus"
              subtle
              xs
              primary
              class="tw-text-pretty tw-break-normal"
              :data-test="`tc-hire-status-${index}`"
            >
              {{ $t('Currently hired') }}
            </WdsLabel>
          </WdsStack>
        </template>

        <template #subText>
          <div class="tw-max-w-[250px]">
            <span
              :class="{
                'tw-text-gray-600': contact.managedStatus === TrustedContactManagedStatus.Unmanaged,
              }"
              :title="contact.title"
            >
              {{ contact.title }}
            </span>
          </div>
        </template>
      </WdsText>
    </WdsStack>
  </WdsStack>
</template>

<script setup lang="ts">
import { WdsAvatar, WdsLabel, WdsStack, WdsText } from '@worksome/wds-components'
import { $t } from '@/composables/translation'
import WorkerName from '@/components/WorkerName.vue'

import { TrustedContactListEntry } from '@/components/Contacts/CompanyFreelancer/composables/trustedContactsList'
import TrustedContactStatusLabel from '@/components/Contacts/CompanyFreelancer/TrustedContactStatusLabel.vue'
import { TrustedContactManagedStatus } from '@/gql/graphql'

interface Props {
  contact: TrustedContactListEntry
  index: Number
  withStatus?: Boolean
  withHireStatus?: Boolean
}

withDefaults(defineProps<Props>(), {
  withStatus: () => true,
  withHireStatus: () => true,
})
</script>
